import * as React from "react";

import {
  InitialStateMinimumRequirements_GraphQl,
  InitialStateMinimumRequirements_LoginPageWithFormKey,
  InitialStateMinimumRequirements_Pack_JoinDrawerFull,
} from "../../../Common";

export interface ReactJoinInitialStateInterface
  extends InitialStateMinimumRequirements_LoginPageWithFormKey,
    InitialStateMinimumRequirements_GraphQl,
    InitialStateMinimumRequirements_Pack_JoinDrawerFull {}

interface ReactJoinInitialStateConsumerInterface {
  initialState: ReactJoinInitialStateInterface;
}

const defaultValue = {
  initialState: {} as ReactJoinInitialStateInterface,
} as unknown as ReactJoinInitialStateConsumerInterface;

const ReactJoinInitialStateContext = React.createContext(defaultValue);

interface ReactJoinInitialStateProviderProps {
  mountElement: Element | null;
}

export const ReactJoinInitialStateProvider: React.FunctionComponent<
  ReactJoinInitialStateProviderProps
> = (props) => {
  const initialState = React.useMemo(() => {
    const mountElement = (props.mountElement || {}) as HTMLElement;

    const initialStateJsonString =
      mountElement?.dataset.reactJoin__initialstate || "{}";

    const initialState = JSON.parse(
      initialStateJsonString
    ) as ReactJoinInitialStateInterface;
    return initialState;
  }, [props.mountElement]);
  return (
    <ReactJoinInitialStateContext.Provider value={{ initialState }}>
      {props.children}
    </ReactJoinInitialStateContext.Provider>
  );
};

export const useReactJoinInitialState =
  (): ReactJoinInitialStateConsumerInterface =>
    React.useContext(ReactJoinInitialStateContext);
